import type { QAReviewWithContent } from "@/types/qaReview";
import { getIssueCount, hasQAReview } from "@/types/qaReview";

interface QASummaryStatsProps {
  reviews: QAReviewWithContent[];
}

export function QASummaryStats({ reviews }: QASummaryStatsProps) {
  const total = reviews.length;
  const withIssues = reviews.filter((r) => getIssueCount(r) > 0).length;
  // "Not reviewed" = no qa_reviews row exists for this post
  const notReviewed = reviews.filter((r) => !hasQAReview(r)).length;
  // "Clean" = has a QA review with zero issues flagged
  const clean = reviews.filter(
    (r) => hasQAReview(r) && getIssueCount(r) === 0
  ).length;

  const cleanPct = total > 0 ? (clean / total) * 100 : 0;
  const issuesPct = total > 0 ? (withIssues / total) * 100 : 0;
  const notReviewedPct = total > 0 ? (notReviewed / total) * 100 : 0;

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-1.5 text-sm text-muted-foreground">
        <span className="font-medium text-foreground">{total} posts</span>
        <span>|</span>
        <span>
          <span className="font-medium text-destructive">{withIssues}</span> with
          issues
        </span>
        <span>|</span>
        <span>
          <span className="font-medium text-orange-500 dark:text-orange-400">{notReviewed}</span> not
          reviewed
        </span>
        <span>|</span>
        <span>
          <span className="font-medium text-green-600 dark:text-green-400">{clean}</span> clean
        </span>
      </div>
      {total > 0 && (
        <div className="w-full h-2.5 rounded-full bg-muted/50 border border-border/50 overflow-hidden flex">
          {cleanPct > 0 && (
            <div
              className="h-full bg-green-500 transition-all duration-300"
              style={{ width: `${cleanPct}%` }}
            />
          )}
          {issuesPct > 0 && (
            <div
              className="h-full bg-red-400 transition-all duration-300"
              style={{ width: `${issuesPct}%` }}
            />
          )}
          {notReviewedPct > 0 && (
            <div
              className="h-full bg-muted-foreground/25 transition-all duration-300"
              style={{ width: `${notReviewedPct}%` }}
            />
          )}
        </div>
      )}
    </div>
  );
}
